import { Icon, IconProps } from './Icon';

export type TelegramProps = IconProps;

const Telegram = (props: TelegramProps) => (
  <Icon fill="none" viewBox="0 0 26.457 21.928" {...props}>
    <path
      fill="currentColor"
      d="M25.115.002h.035c.34 0 .656.105.915.288L26.06.286c.189.165.315.396.346.656v.005a4.146 4.146 0 0 1 .04.973v-.015c-.367 3.854-1.954 13.2-2.761 17.514-.342 1.827-1.014 2.439-1.665 2.498-1.413.131-2.487-.934-3.857-1.832-2.144-1.407-3.356-2.283-5.437-3.654-2.406-1.583-.846-2.457.524-3.878.36-.375 6.592-6.044 6.714-6.558a.502.502 0 0 0-.114-.431.552.552 0 0 0-.3-.087.592.592 0 0 0-.209.04l.003-.002c-.214.049-3.64 2.312-10.275 6.79a4.564 4.564 0 0 1-2.634.975h-.01a17.15 17.15 0 0 1-3.905-.932l.12.039c-1.526-.498-2.738-.76-2.634-1.603.056-.438.66-.886 1.813-1.345C8.92 6.345 13.656 4.305 16.026 3.32 18.64 1.933 21.67.79 24.858.05l.255-.05z"
    />
  </Icon>
);

export { Telegram };
